import { Outlet, createRootRoute } from '@tanstack/react-router';
import * as Sentry from '@sentry/react';
import { useTranslation } from 'react-i18next';
import { describeError } from '@s2w/core';
import { GameShell } from '../components/layout';

const includeErrorDetails = import.meta.env.DEV;

const RootFallback = ({ error }: { error: unknown }) => {
  const { t } = useTranslation('errors');
  return (
    <main
      role="alert"
      className="bg-transparent text-text-primary flex min-h-dvh items-center justify-center p-6"
    >
      <div className="max-w-md space-y-2 text-center">
        <h1 className="text-xl font-semibold">{t('generic')}</h1>
        <p className="text-text-secondary text-sm">
          {describeError(error, { includeDetails: includeErrorDetails })}
        </p>
      </div>
    </main>
  );
};

const RootComponent = () => (
  <Sentry.ErrorBoundary fallback={({ error }) => <RootFallback error={error} />}>
    <GameShell>
      <Outlet />
    </GameShell>
  </Sentry.ErrorBoundary>
);

export const Route = createRootRoute({
  component: RootComponent,
});
